import { Stack } from "@chakra-ui/react";

export default function Container({ children, submitRef, onSubmit = () => {}, ...props }){

    const handleSubmit = e => {
        e.preventDefault()
        onSubmit(e)
    }

    return(
    <Stack as="form" gap={4} onSubmit={handleSubmit} {...props}>
        {children}
        <input type="submit" style={{ display: 'none' }} ref={submitRef} />
    </Stack>
    )
}